module.exports = __webpack_public_path__ + "img/upload-default.c9b96271.png";